let pendingFetch = null;

// Effectue une requête fetch exclusive afin d'éviter une expiration de session si les tokens d'accès sont renouvellés durant l'opération.
async function fetchExclusive(url, options) {
  if (pendingFetch) {
    await pendingFetch.catch(() => {});
    return await fetchExclusive(url, options);
  }

  const promise = options ? fetch(url, options) : fetch(url);
  pendingFetch = promise;

  try {
    return await promise;
  } finally {
    if (pendingFetch === promise) {
      pendingFetch = null;
    }
  }
}

export default fetchExclusive;
